import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import * as API from "../../api";

export const get_list = createAsyncThunk(
  "client/get_list",
  async (props, { rejectWithValue, signal }) => {
    try {
      // const controller = new AbortController()

      // signal.addEventListener("abort", () => controller.abort());

      const { data, status } = await API.getClients(props.controller);

      console.log(data);

      return { data: data, message: data.message, status };
    } catch (err) {
      console.log(err);
      const { status } = err.response;
      const { data, message } = err.response.data;
      return rejectWithValue({ data, message, status });
    }
  }
);

export const clientSlice = createSlice({
  name: "client",
  initialState: {
    loading: false,
    status: "idle",
    error: null,
    list: null,
    counts: { total: null },
    clientDetails: null,
  },
  reducers: {
    get_client_details: (state, action) => {
      state.clientDetails = action.payload;
    },
  },
  extraReducers: {
    [get_list.pending]: (state, action) => {
      state.status = "loading";
      state.loading = true;
      state.error = null;
    },
    [get_list.fulfilled]: (state, action) => {
      state.list = [...action.payload.data.data];
      state.counts = { ...state.counts, total: action.payload.data.total };
      state.status = "idle";
      state.loading = false;
    },
    [get_list.rejected]: (state, action) => {
      state.error = { ...action.payload };
      state.status = "failed";
      state.loading = false;
    },
  },
});

export const { get_client_details } = clientSlice.actions;

export default clientSlice.reducer;
